import React, { useState, useEffect } from 'react'
import { MessageBus, MessageBusTypes } from 'common-tools/MessageBusHelper'
import { Button, CatchError } from 'common-controls/Core'
import styles from './DrawerContainer.less'
import _ from 'common-tools/LodashHelper'
import { log } from 'common-tools/index'
import { compose, ReduxWrapper, ah, sh } from 'common-data/datahelpers'
import { motion, AnimatePresence } from 'framer-motion'
import { useWindowSize } from 'common-controls/Core/Hooks/useWindowResize'

const DrawerBoxVariants = {
  animate: {
    x: 0,
    transition: {
      duration: 0.600,
      ease: 'easeIn'
    }
  },
  exit: {
    x: '100%',
    transition: {
      duration: 0.400,
      ease: 'easeOut'
    }
  },
  initial: {
    x: '175%'
  }
}

const MiddleBoxVariants = {
  animate: {
    y: 0,
    transition: {
      duration: 0.600,
      ease: 'easeIn'
    }
  },
  exit: {
    y: '100%',
    transition: {
      duration: 0.400,
      ease: 'easeOut'
    }
  },
  initial: {
    y: '175%'
  }
}

const StaticBoxVariants = {

}

const PopupBoxVariants = {
  animate: {
    y: 0,
    transition: {
      duration: 0.600,
      ease: 'easeIn'
    }
  },
  exit: {
    y: '-250%',
    transition: {
      duration: 0.400,
      ease: 'easeOut'
    }
  },
  initial: {
    y: '-250%'
  }
}

const OverlayBoxVariants = {
  animate: {
    opacity: 0.4,
    delay: 0.500,
    transition: {
      duration: 1
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.400
    }
  },
  initial: {
    opacity: 0
  }
}

function EmptyDrawer (props) {
  return <div style={{ drawerStyle: props.drawerStyle }}>
    <p>Empty Drawer!</p>
    <Button type='Danger' onClick={props.close}>Close</Button>
  </div>
}

function DrawerContainerPlain (props) {
  const { DrawerList = [], closeDrawer, showError } = props

  const windowSize = useWindowSize()

  const [drawers, setDrawers] = useState([])
  const [backdropStyle, setBackDropStyle] = useState({
    position: 'relative'
  })

  useEffect(() => {
    if (drawers.length > 0) {
      setBackDropStyle({
        ...backdropStyle,
        height: window.innerHeight
      })
    }
  }, [windowSize])

  useEffect(() => {
    if (DrawerList.length > 0) {
      document.body.classList.add('no-overflow')
      setBackDropStyle({
        position: 'absolute',
        top: window.pageYOffset,
        height: window.innerHeight
      })

      const items = []
      _.each(DrawerList, (d, i) => {
        let drawerSize = d.drawerSize || 'Half'
        let drawerProps = d.props || {}
        let DrawContents = d.component || EmptyDrawer
        let messageBusKey = d.messageBusKey

        let zIndexStyle = {
          zIndex: 1000 + i
        }

        items.push(
          <motion.div {...OverlayBoxVariants} key={`drawer-overlay-${i}`} style={zIndexStyle} className={styles.overlay} />
        )

        let BoxVariants = DrawerBoxVariants

        if (_.startsWith(drawerSize, 'Popup')) {
          BoxVariants = PopupBoxVariants
        } else if (_.startsWith(drawerSize, 'Middle')) {
          BoxVariants = MiddleBoxVariants
        } else if (drawerSize === 'Static') {
          BoxVariants = StaticBoxVariants
        }

        items.push(
          <motion.div {...BoxVariants} key={`drawer-${i}`} style={zIndexStyle} className={styles[`drawer${drawerSize}`]}>
            <DrawContents close={(actions) => {
              try {
                MessageBus.send(MessageBusTypes.DrawEvents, { actions: actions, messageBusKey: messageBusKey })
              } catch (err) {
                log.Error('Drawer Post Action CallBack Error', { Error: err })
                showError('Unable to complete post action callbacks, see console for details!')
              }
              closeDrawer(d.key)
            }} fire={(actions) => {
              try {
                MessageBus.send(MessageBusTypes.DrawEvents, { actions: actions, messageBusKey: messageBusKey })
              } catch (err) {
                log.Error('Drawer Fire Event CallBack Error', { Error: err })
                showError('Unable to complete fire event callbacks, see console for details!')
              }
            }} {...drawerProps} />
          </motion.div>
        )
      })
      setDrawers(items)
    } else if (DrawerList.length === 0) {
      document.body.classList.remove('no-overflow')
      setDrawers([])
    }
  }, [DrawerList.length])

  return (
    <div style={backdropStyle} key='drawerBackdrop' className={styles.drawerBackdrop}>
      <CatchError withClassNames={styles.drawerCatchError}>
        <AnimatePresence onExitComplete={() => {
          if (drawers.length === 0) {
            setBackDropStyle({
              position: 'relative',
              top: '0px',
              height: '0px'
            })
          }
        }}>
          {drawers}
        </AnimatePresence>
      </CatchError>
    </div>
  )
}

// class DrawerContainerPlain2 extends React.Component {
//   constructor (props) {
//     super(props)

//     this.state = {
//       openDrawers: false
//     }
//   }

//   componentDidUpdate (prevProps, prevState) {
//     const { openDrawers } = this.state

//     const openDrawersDiff = componentGetCompareProps('DrawerList.length', this.props, prevProps, 0)

//     if (openDrawersDiff.Current > 0 & openDrawers === false) {
//       console.log('drawer open')
//       document.body.classList.add('no-overflow')
//       this.setState({
//         openDrawers: true
//       })
//     } else if (openDrawersDiff.Current === 0) {
//       console.log('drawer close')
//       document.body.classList.remove('no-overflow')
//     }
//   }

//   getEmptyDrawer () {
//     return (props) => {
//       return <div style={{ drawerStyle: props.drawerStyle }}>
//         <p>Empty Drawer!</p>
//         <Button type='Danger' onClick={this.props.close}>Close</Button>
//       </div>
//     }
//   }

//   renderDrawers () {
//     const { DrawerList, closeDrawer, showError } = this.props

//     let drawerList = []
//     // let lastSize = ''

//     _.each(DrawerList, (d, i) => {
//       let drawerSize = d.drawerSize || 'Half'
//       let drawerProps = d.props || {}
//       let DrawContents = d.component || this.getEmptyDrawer()
//       let messageBusKey = d.messageBusKey

//       let zIndexStyle = {
//         zIndex: 1000 + i
//       }

//       drawerList.push(
//         <motion.div {...OverlayBoxVariants} key={`drawer-overlay-${i}`} style={zIndexStyle} className={styles.overlay} />
//       )

//       let BoxVariants = DrawerBoxVariants

//       if (_.startsWith(drawerSize, 'Popup')) {
//         BoxVariants = PopupBoxVariants
//       } else if (_.startsWith(drawerSize, 'Middle')) {
//         BoxVariants = MiddleBoxVariants
//       } else if (drawerSize === 'Static') {
//         BoxVariants = StaticBoxVariants
//       }

//       drawerList.push(
//         <motion.div {...BoxVariants} key={`drawer-${i}`} style={zIndexStyle} className={styles[`drawer${drawerSize}`]}>
//           <DrawContents close={(actions) => {
//             try {
//               MessageBus.send(MessageBusTypes.DrawEvents, { actions: actions, messageBusKey: messageBusKey })
//             } catch (err) {
//               log.Error('Drawer Post Action CallBack Error', { Error: err })
//               showError('Unable to complete post action callbacks, see console for details!')
//             }
//             closeDrawer(d.key)
//           }} fire={(actions) => {
//             try {
//               MessageBus.send(MessageBusTypes.DrawEvents, { actions: actions, messageBusKey: messageBusKey })
//             } catch (err) {
//               log.Error('Drawer Fire Event CallBack Error', { Error: err })
//               showError('Unable to complete fire event callbacks, see console for details!')
//             }
//           }} {...drawerProps} />
//         </motion.div>
//       )

//       // lastSize = drawerSize
//     })

//     return drawerList
//   }

//   render () {
//     const { openDrawers } = this.state

//     return (
//       <div style={{ position: openDrawers === true ? 'absolute' : 'relative' }} key='drawerBackdrop' className={styles.drawerBackdrop}>
//         <CatchError withClassNames={styles.drawerCatchError}>
//           <AnimatePresence onExitComplete={() => { this.setState({ openDrawers: false }) }}>
//             {this.renderDrawers()}
//           </AnimatePresence>
//         </CatchError>
//       </div>
//     )
//   }
// }

export const DrawerContainer = compose(
  ReduxWrapper([
    sh.DrawerList
  ], [
    ah.closeDrawer,
    ah.showError
  ])
)(DrawerContainerPlain)

export default DrawerContainer
